/* 🤖 this file was generated by svg-to-ts */
export var spxIconCancel01 = {
    name: 'cancel_01',
    data: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 5L5 19M5 5L19 19\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>"
};
